
// 配置审图要点 英文版
const kte_checklist_en = [
    {
        "name": "Architecture Specialty - General Layout",
        "children": [
            {
                "name": "Quality Impact",
                "children": [
                    {
                        "name": "Floor Plan Layout",
                        "children": [
                            {
                                "name": "1. The settings of functional parts such as underground garage entrances/exits (including non-motorized ones), civil air defense openings, underground pump rooms, box-type transformers, fire-fighting water intakes, septic tanks, and air outlets are correct and reasonable, without adverse impact on the building.",

                            },
                            {
                                "name": "2. Whether the positioning of squares, parking lots, sports fields, roads, barrier-free facilities, drainage ditches, retaining walls, slope protection, etc. is correct, and whether the elevation and slope are correct and reasonable.",

                            },
                            {
                                "name": "3. Whether the turning radius of the traffic lanes meets the requirements of traffic flow lines, and whether the turning and parking of places with large (coach) vehicle traffic and distribution requirements meet the requirements.",

                            },
                            {
                                "name": "4. The slope of roads and sites is set reasonably to facilitate vehicle passage, the distance from the outer wall of the building is reasonable, and each functional area has good accessibility, such as connecting to fire-fighting facilities, garbage transfer facilities, septic tanks, logistics unloading and other functional areas.",

                            },
                            {
                                "name": "5. The functional zoning is reasonable, with little impact and interference. In particular, functions that generate noise, odors, light pollution, and heat sources should be kept away from the building as much as possible or shielded.",

                            },
                            {
                                "name": "6. Whether the height difference treatment between the vertical elevation of roads and sites and the building's plus-minus zero elevation is reasonable, and whether the needs of barrier-free passage are considered.",

                            }
                        ]
                    },
                    {
                        "name": "Underground Garage Air Outlets",
                        "children": [
                            {
                                "name": "1. Ground-level air shafts should be arranged in conjunction with the gable of the building, placed close to the above-ground building, not in the main line of sight, and should be equipped with fences and other decorations to optimize the visual effect.",

                            },
                            {
                                "name": "2. Vehicle entrances and exits should meet the sight triangle, and vehicle flow lines and functional entrance zoning management. Vehicle entrances and exits connected to the main road should be provided with a slow-down area.",

                            },
                            {
                                "name": "3. In addition to meeting the code requirements for the distance from the building, the ground-level air supply and exhaust outlets of the basement should also consider sight shielding, aesthetics, and noise impact.",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "Regulatory Risks",
                "children": [
                    {
                        "name": "Compliance with Setback Lines",
                        "children": [
                            {
                                "name": "1. Buildings and auxiliary facilities must not protrude beyond the road red line, land red line, or building control line.",

                            },
                            {
                                "name": "2. The outer contour, positioning, vertical elevation of the building are consistent with the planning scheme, planning report text, and the outline of the basement unit.",

                            }
                        ]
                    },
                    {
                        "name": "Road Grade and Width",
                        "children": [
                            {
                                "name": "1. The width, turning radius, and height of fire-fighting lanes should meet the specifications. The size, location, and size of the turning yard of the fire-fighting rescue site meet the specifications.",

                            },
                            {
                                "name": "2. The distance between the road and the outer wall of the building meets the specifications.",

                            }
                        ]
                    },
                    {
                        "name": "Underground Garage Entrances/Exits",
                        "children": [
                            {
                                "name": "1. The distance between the starting slope point of the basement entrance/exit and the road red line and road edge meets the specifications.",

                            },
                            {
                                "name": "2. Both the starting and ending ends of the basement entrance/exit are equipped with intercepting ditches. When the length of the open-air lane exceeds 5 meters, an intermediate intercepting ditch is set.",

                            }
                        ]
                    },
                    {
                        "name": "Setback/Distance",
                        "children": [
                            {
                                "name": "1. Whether the layout of the general layout plan is reasonable, and whether the distance between buildings and pipelines, structures, green plants, and other buildings meets the specification requirements, and whether the elevation is correct.",

                            }
                        ]
                    },
                    {
                        "name": "Technical and Economic Indicators",
                        "children": [
                            {
                                "name": "1. The number of motor vehicle and non-motor vehicle parking spaces, the number of charging parking spaces in the above-ground and underground parts should be consistent with the drawings. The calculation and conversion statistics of the greening rate should be consistent with the indicators according to the rules, and the sunlighting meets the specification requirements.",

                            },
                            {
                                "name": "2. The general technical and economic indicators should be consistent with the single-unit statistics (important), especially the floor area ratio, supporting area, plot ratio, greening rate, building density, number of parking spaces, civil air defense area, etc.",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "Floor Plan Layout",
                "children": [
                    {
                        "name": "Errors, Omissions, Conflicts and Deficiencies",
                        "children": [
                            {
                                "name": "1. Fire-fighting water intakes and fire water tanks need to be expressed on the general layout.",

                            },
                            {
                                "name": "2. There are no omissions in the design of site stairs and elevators.",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "Architecture Specialty - Basement",
        "children": [
            {
                "name": "Quality Impact",
                "children": [
                    {
                        "name": "Parking Spaces",
                        "children": [
                            {
                                "name": "1. Frame columns, fire hydrants, equipment boxes, partition walls, and civil air defense doors should meet the requirements for door opening and the net width of parking spaces.",

                            },
                            {
                                "name": "2. The arrangement of basement column grids should not affect door opening, and the distance from the front end of the parking space to the rear end of the side column should not be greater than 1.6 meters.",

                            }
                        ]
                    },
                    {
                        "name": "Main Factors Affecting Basement Floor Height",
                        "children": [
                            {
                                "name": "1. The basement floor height should consider: structural height, ventilation pipe height, sprinkler head height, clear height of parking spaces, and the height of the ground and wear-resistant layer (including slope finding).",

                            },
                            {
                                "name": "2. Height of equipment pipeline layer: (for civil air defense requiring smoke exhaust/air ducts/sprinklers) not exceeding 650mm, and should be controlled at 550mm as much as possible when conditions permit.",

                            }
                        ]
                    },
                    {
                        "name": "Waterproofing of Garage Entrance/Exit Ramps",
                        "children": [
                            {
                                "name": "1. The retaining walls on both sides of the lane entrance/exit should adopt the same waterproof and drainage measures as the side walls of the basement to prevent environmental water from seeping into the lane area.",

                            },
                            {
                                "name": "2. A reverse slope should be set at the entrance of the basement entrance/exit ramp to prevent rainwater from backflowing.",

                            },
                            {
                                "name": "3. Reverse sills should be set around the entrance/exit ramp to prevent rainwater from backflowing.",

                            },
                            {
                                "name": "4. Intercepting ditches should be set at the entrance and end of the entrance/exit ramp.",

                            },
                            {
                                "name": "5. The side walls of the garage entrance/exit should adopt measures such as tiling to prevent efflorescence, blistering, and delamination, and coordinate with the overall style.",

                            }
                        ]
                    },
                    {
                        "name": "Basement Drainage",
                        "children": [
                            {
                                "name": "1. Sump pits should be preferentially set in non-parking spaces and non-lane areas, and should not be set in pedestrian passages or elevator lobbies.",

                            }
                        ]
                    },
                    {
                        "name": "Garage Entrances/Exits",
                        "children": [
                            {
                                "name": "1. The clear height of the underground entrance and interior should not be less than 2400mm, and a barrier-free ramp should be added when there is a height difference at the entrance.",

                            }
                        ]
                    },
                    {
                        "name": "Basement Stairs",
                        "children": [
                            {
                                "name": "1. The number of stairs leading to the ground should be minimized and combined with the garden.",

                            },
                            {
                                "name": "2. Stairs need to be equipped with safety railings.",

                            }
                        ]
                    },
                    {
                        "name": "Others",
                        "children": [
                            {
                                "name": "1. All equipment rooms should not cross structural joints.",

                            },
                            {
                                "name": "2. Generator rooms should be designed with open ditch drainage, and the rooms above the generator room should not be water-related rooms, and the ground should be provided with a waterproof layer.",

                            },
                            {
                                "name": "3. Water meter rooms should be equipped with drainage floor drains and thresholds.",

                            },
                            {
                                "name": "4. Fire-resistant rolling shutters should be set at the entrances and exits of car ramps.",

                            },
                            {
                                "name": "5. The elevation of the bottom of the underground power distribution room trench is strictly prohibited to be lower than the drainage elevation, which may cause water accumulation.",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "Cost Control",
                "children": [
                    {
                        "name": "Fire Door Grade",
                        "children": [
                            {
                                "name": "1. The grade of fire doors and windows should comply with the specification requirements and must not be higher than the specification grade, resulting in cost waste.",

                            }
                        ]
                    },
                    {
                        "name": "Equipment Room Location",
                        "children": [
                            {
                                "name": "1. Equipment rooms should be arranged in less utilized positions and must not occupy the optimal parking spaces, resulting in a reduction in the number of parking spaces.",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "Regulatory Risks",
                "children": [
                    {
                        "name": "Economic and Technical Indicators",
                        "children": [
                            {
                                "name": "1. Building economic and technical indicators (preliminary design, construction drawings, completion).",

                            }
                        ]
                    },
                    {
                        "name": "Setting of Charging Vehicle Areas",
                        "children": [
                            {
                                "name": "1. If there is a \"one-time construction\" charging parking area, its location should be reflected. It should not be set in low-lying areas prone to water accumulation; nor in places with severe vibration or high temperature.",

                            }
                        ]
                    },
                    {
                        "name": "Elevator Pit Drainage",
                        "children": [
                            {
                                "name": "1. All elevators should be equipped with waterproofing and drainage measures (except food elevators). Drainage pipes and sump pits should be set, and the sump pit should not receive other drainage outside the elevator pit. It is strictly prohibited to share the elevator pit with the rainwater drainage sump pit.",

                            }
                        ]
                    },
                    {
                        "name": "Evacuation Passage Width",
                        "children": [
                            {
                                "name": "1. The unit entrance connected to the basement garage should be a steel fire door, and the parking space should meet the 1.2m evacuation width.",

                            }
                        ]
                    },
                    {
                        "name": "Anti-falling Measures",
                        "children": [
                            {
                                "name": "1. There should be facilities to prevent falling objects above the entrances and ramps leading to the garage.",

                            }
                        ]
                    },
                    {
                        "name": "Slope of Slab Parking",
                        "children": [
                            {
                                "name": "1. When parking on a sloping slab, the slope of the driveway (parking area) should be ≤5%.",

                            }
                        ]
                    },
                    {
                        "name": "Application of New Technologies",
                        "children": [
                            {
                                "name": "1. Whether the application of new materials and technologies is reasonable, and whether the practices of building shapes and structures are complete, feasible, and reasonable.",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "Errors, Omissions, Conflicts and Deficiencies",
                "children": [
                    {
                        "name": "Drawing Depth",
                        "children": [
                            {
                                "name": "1. The basement roof plan should express the drainage slope, slope direction, and different elevations everywhere.",

                            },
                            {
                                "name": "2. The reserved openings and casing drawings of shear walls and civil air defense walls should be clear and complete. Civil air defense construction should be formed in one time, and post-opening is not allowed. The piping in narrow passages should be arranged reasonably to avoid affecting the height.",

                            }
                        ]
                    },
                    {
                        "name": "Consistency",
                        "children": [
                            {
                                "name": "1. The vertical components of the basement must be consistent with the structural specialty to avoid problems such as damaged parking space dimensions due to inconsistent vertical components.",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "Architecture Specialty - Single Building",
        "children": [
            {
                "name": "Quality Impact",
                "children": [
                    {
                        "name": "Floor Plan Layout",
                        "children": [
                            {
                                "name": "1. Structural vertical components must not seriously affect the internal use function of the building.",

                            },
                            {
                                "name": "2. Outdoor elevators (stairs), structural vertical components, corridor columns, shapes, air outlets, air shafts, etc. must not be set on pedestrian flow lines.",

                            }
                        ]
                    },
                    {
                        "name": "Door Opening Reverse Sill",
                        "children": [
                            {
                                "name": "1. All exterior walls on terraces and roofs, parapets, roof ventilation ducts, and buildings (air shafts, stairwells, etc.) above the basement roof should be provided with concrete reverse sills with a height of not less than 400mm (thickness the same as the wall); concrete reverse sills should also be used under the roof access doors of stairwells. All roof reverse sills should be poured together with the main structure (concrete strength the same as the floor slab).",

                            }
                        ]
                    },
                    {
                        "name": "Railing Reverse Sill",
                        "children": [
                            {
                                "name": "1. The railing detail should mark the width of the reverse sill to determine whether it is a踏面 (tread). The width of the balcony reverse sill should be designed as 120mm in principle.",

                            }
                        ]
                    },
                    {
                        "name": "Railing Safety",
                        "children": [
                            {
                                "name": "1. Railings longer than 3.6m-4m should be marked with dimensions and注明 the reinforced structural做法.",

                            }
                        ]
                    },
                    {
                        "name": "Door and Window Installation",
                        "children": [
                            {
                                "name": "1. All doors must be provided with door jambs; when door jambs are not easy to build, constructional columns can be set or poured together with the main structure.",

                            }
                        ]
                    },
                    {
                        "name": "Facade Effect",
                        "children": [
                            {
                                "name": "1. Vertical pipes such as roof drainage pipes and canopy drainage pipes should be centrally arranged in hidden places and have the same color as the external wall.",

                            }
                        ]
                    },
                    {
                        "name": "Clear Height Control",
                        "children": [
                            {
                                "name": "1. Whether the axis and dimension marking of the building floor plan are correct, and whether the floor height and clear height of the building can meet the requirements.",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "Cost Control",
                "children": [
                    {
                        "name": "Door and Window Installation",
                        "children": [
                            {
                                "name": "1. The grade of fire doors and windows should not be higher than the specification requirements, resulting in cost waste.",

                            },
                            {
                                "name": "2. Whether the selection, height, opening method, and division method of doors and windows are reasonable, and whether they meet the requirements of ventilation and safety. Review whether the material and color of doors and windows are coordinated with the facade effect.",

                            }
                        ]
                    },
                    {
                        "name": "Wall Masonry",
                        "children": [
                            {
                                "name": "1. When the wall thickness has no impact on equipment wiring and installation and meets the fire protection specifications, it should be made 100mm thick.",

                            }
                        ]
                    },
                    {
                        "name": "Construction Rationality",
                        "children": [
                            {
                                "name": "1. In the wall detail做法 (practice), there should be no structural cavity that cannot be removed by the structural formwork.",

                            }
                        ]
                    },
                    {
                        "name": "Material Selection",
                        "children": [
                            {
                                "name": "1. Economy, procurement convenience, and construction feasibility of exterior decoration materials.",

                            }
                        ]
                    },
                    {
                        "name": "Air-Conditioning Unit Positions",
                        "children": [
                            {
                                "name": "1. Whether the design of the facade lines is reasonable, and whether the setting of the external wall air-conditioning unit positions is reasonable and convenient for installation.",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "Regulatory Risks",
                "children": [
                    {
                        "name": "Evacuation Width",
                        "children": [
                            {
                                "name": "1. Structural components or other structures, landscapes, and decorations must not affect the effective passage width of the eaves gallery (passage).",

                            }
                        ]
                    },
                    {
                        "name": "Stair Clear Height and Width",
                        "children": [
                            {
                                "name": "1. The clear height of the upper and lower parts of the stair platform (calculated from the lowest point, i.e., the bottom of the platform beam) should not be less than 2m; the clear height of the stair flight should not be less than 2.2m. When the clear height is small to ensure no head collision, the starting position of the stair flight steps should be set back one step width or 300mm from the edge of the platform beam. The minimum width at the handrail of the stair platform should not be less than the width of the stair flight.",

                            }
                        ]
                    },
                    {
                        "name": "Railing Height",
                        "children": [
                            {
                                "name": "1. Railings at the edge of balconies, verandas, indoor corridors, inner patios, accessible roofs, and outdoor stairs of various buildings should be made of firm and durable materials. The height of the railing should not be less than 1.05m. High-rise buildings should be appropriately increased, but not more than 1.2m. In places with children's activities, railings should adopt non-climbable structures. The height of the railing handrail of residential stairs should not be less than 0.90m. When the length of the horizontal railing exceeds 0.50m, its height should not be less than 1.05m, and the clear space between the vertical bars of the railing should not be greater than 0.11m. The height of the railing should be calculated from the lower踏面 (tread) to ensure a clear height of 0.9m.",

                            }
                        ]
                    },
                    {
                        "name": "Window Sill Height",
                        "children": [
                            {
                                "name": "1. Protective measures should be taken when the window sill is lower than 0.80m. Protective facilities should be installed when the net height from the outer window sill to the floor is lower than 0.90m. The net height of the window sill or protective railing should be calculated from the踏面 (tread) to ensure a clear height of 0.9m.",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "Errors, Omissions, Conflicts and Deficiencies",
                "children": [
                    {
                        "name": "Drawing Depth",
                        "children": [
                            {
                                "name": "1. Construction drawings should include the positioning and reinforcement requirements of all constructional columns.",

                            },
                            {
                                "name": "2. The opening direction of windows should be clearly indicated in the door and window details.",

                            },
                            {
                                "name": "3. All roof water tanks and fans need to be positioned in the architectural drawings, and the specific method of the foundation should be given.",

                            },
                            {
                                "name": "4. All stairs should have floor plans and sections that match the dimensions of structural components, with complete expression of positioning dimensions, elevations, step heights, and step widths.",

                            },
                            {
                                "name": "5. Stairwell windows should be set at the landing; they should not conflict with stair beams and stair columns;",

                            },
                            {
                                "name": "6. All floor openings should have positioning and opening dimensions, and all openings should consider fire protection, waterproofing, and drainage treatment.",

                            },
                            {
                                "name": "7. Each floor plan should have closed polylines for area calculation under an independent layer, and the area calculation rules should comply with the requirements of the local government where the project is located.",

                            },
                            {
                                "name": "8. There should be elevator sections (expressing the machine room floor, pit), landing door elevations, and the reserved holes for floor indicators and the reserved positions for call boxes should be indicated according to the elevator brand.",

                            },
                            {
                                "name": "9. The width and height of the reserved elevator door openings should be considered according to the actual architectural decoration practices.",

                            },
                            {
                                "name": "10. The material legend and color number in the elevation drawing are completely expressed.",

                            },
                            {
                                "name": "11. The basement needs door and window statistics.",

                            },
                            {
                                "name": "12. The elevator lobbies in the basement and all rooms need to indicate the area, and rooms with elevation changes need to indicate the elevation.",

                            }
                        ]
                    },
                    {
                        "name": "Consistency",
                        "children": [
                            {
                                "name": "1. The door and window division method and railing做法 (practice) are consistent with the model room.",

                            },
                            {
                                "name": "2. All decorative frames and non-permanent components should be marked with text; decorative louvers should be numbered together with door and window louvers without omission.",

                            },
                            {
                                "name": "3. The position of fire hydrants is expressed in the plan, set reasonably, and consistent with the standard.",

                            },
                            {
                                "name": "4. The plan, elevation, section, and building nodes are consistent.",

                            },
                            {
                                "name": "5. The elevations of different parts of the plan and room areas should be completely marked.",

                            },
                            {
                                "name": "6. Elevation system, elevation relationship between various functional rooms, and whether the floor depression is correct.",

                            }
                        ]
                    },
                    {
                        "name": "Elevator Parameters",
                        "children": [
                            {
                                "name": "1. The elevator shaft size should be set according to the assigned brand, and can be 30-50mm larger than the (minimum) installation size of the elevator; the buffer height at the bottom and top of the elevator meets the elevator installation requirements.",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "Architecture Specialty - Decoration",
        "children": [
            {
                "name": "Quality Impact",
                "children": [
                    {
                        "name": "Railing Safety",
                        "children": [
                            {
                                "name": "1. The height of the lower base of the railing should not be less than 200mm to avoid the skirting height exceeding the base after decoration and paving, which affects the closing and effect.",

                            }
                        ]
                    },
                    {
                        "name": "Door and Window Installation",
                        "children": [
                            {
                                "name": "1. The installed elevation of door openings and doors and windows must be reserved strictly according to the reference elevation of decoration completion, especially the installation elevation of aluminum alloy doors and interior doors; ensure that it does not affect opening use and aesthetic effect after decoration.",

                            },
                            {
                                "name": "2. The positioning and thickness of all walls should consider the actual layout of ceiling beams and space. For example, the door jamb of a room should be 100mm if possible, and at least 50mm; ensure that the clear space of the door opening meets the use requirements after the decoration door pocket is installed.",

                            },
                            {
                                "name": "3. The installation position of fire doors must not affect the decoration closing.",

                            },
                            {
                                "name": "4. Whether the elevator door opening wall meets the requirements of dry-hanging stone.",

                            }
                        ]
                    },
                    {
                        "name": "Equipment Opening Reservation",
                        "children": [
                            {
                                "name": "1. The setting position of air conditioning refrigerant pipe holes should try not to affect the placement of indoor wardrobes, bookcases, and other cabinets.",

                            }
                        ]
                    },
                    {
                        "name": "Clear Height Control",
                        "children": [
                            {
                                "name": "1. Whether the reserved holes for ventilation fan pipes affect the height of the decoration ceiling.",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "Architecture Specialty - Landscape",
        "children": [
            {
                "name": "Errors, Omissions, Conflicts and Deficiencies",
                "children": [
                    {
                        "name": "Consistency",
                        "children": [
                            {
                                "name": "1. During the construction drawing stage, the load of local landscape lane curves should meet the fire-fighting function; the climbing surface and turning yard should not affect the major nodes of the landscape.",

                            },
                            {
                                "name": "2. The setting of entrance sentry boxes should meet the width of the fire-fighting lane, and the fire-fighting lane should be confirmed with the landscape during the application for construction.",

                            }
                        ]
                    },
                    {
                        "name": "Road Slope",
                        "children": [
                            {
                                "name": "1. The relationship between road elevation and building connection, and whether the road slope is reasonable.",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "Structural Specialty - Basement",
        "children": [
            {
                "name": "Quality Impact",
                "children": [
                    {
                        "name": "Floor Plan Layout",
                        "children": [
                            {
                                "name": "1. Structural components must not seriously affect the building's facade effect.",

                            },
                            {
                                "name": "2. Vertical components must not seriously affect the internal use function of the building and meet the requirements of building door and window opening dimensions.",

                            },
                            {
                                "name": "3. The beam height should meet the clear height requirements of the building or decoration and should not affect the installation of building doors and windows.",

                            },
                            {
                                "name": "4. The design of inverted beams must not affect the use of upper rooms (platforms), and the inverted beams on the roof should be designed with drainage holes.",

                            }
                        ]
                    }
                ]
            }
        ]
    }
]


export default kte_checklist_en
